import React, {useState} from 'react';
import styled from 'styled-components';

import Row from "./../../../common/components/Row.js";
import Col from "./../../../common/components/Col.js";
import Card from "./../../../common/components/Card.js";
import Button from "./../../../common/components/Button.js";
import Typo from "./../../../common/components/Typo.js";
import Input from "./../../../common/components/Input.js";

const Error = styled.div.withConfig({displayName:'-Error'})`
  height: 30px;
  color: red;
`;

const FormNewPassword = ({sessionUser, onConfirm, error}) => {
  const [password1, setPassword1] = useState('');
  const [password2, setPassword2] = useState('');
  const [code, setCode] = useState('');


  return (

    <Card>
      <Typo variant="h1">New password</Typo><br/>
      <>Hi. Change of your password is required.</>

      <Row>
        <Col widthmd="12">
          <Input
            label={"Code"}
            name="code"
            type="text"
            width="100%"
            value={code}
            onChange={(val) => setCode(val)}
            required
          />
        </Col>
        <Col widthmd="12">
          <Input
            label={"Password"}
            name="password1"
            type="password"
            width="100%"
            value={password1}
            onChange={(val) => setPassword1(val)}
            required
          />
        </Col>
        <Col widthmd="12">
          <Input
            label={"Repeat password"}
            name="password2"
            type="password"
            width="100%"
            value={password2}
            onChange={(val) => setPassword2(val)}
            required
          />
        </Col>
        <Col widthmd="12">
          <Button onClick={() => onConfirm({
            action: "new-password",
            params: {
              password1: password1,
              password2: password2,
              code: code
            }
          })}>Confirm</Button>
        </Col>
        <Col widthmd="12">
          <Error>
            <br/>{error}<br/>
          </Error>
        </Col>
      </Row>
    </Card>
  )
}

export default FormNewPassword;
